module.exports = __webpack_public_path__ + "f090e8c1df408e74c3f7b296ffdf20d2.svg";